import { styled } from '@lichtblick/styled';
import { Spacing } from '@lichtblick/theme';

export const Container = styled.div`
  width: inherit;
  align-items: center;
  display: flex;
  justify-content: space-between;
`;

export const NamePlate = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Controls = styled.div`
  align-items: center;
  display: flex;
  gap: ${Spacing.Xs};

  svg {
    cursor: pointer;
  }
`;

export const ContactRow = styled.div`
  display: flex;
  gap: ${Spacing['Xxs']};
  margin: ${Spacing['Xxs']} 0;
  svg {
    height: 1rem;
    width: 1rem;
  }
`;
